import {
  Dropdown,
  type DropdownProps,
  type OptionType,
  type SingleValue,
} from '@omnipresentgroup/design-system';
import { toSentenceCase } from '@omnipresentgroup/helpers';
import { CompensationSource } from '@omnipresentgroup/types';
import { useSearchParams } from 'react-router';

import {
  COMPENSATION_SOURCE_LABELS,
  COMPENSATION_SOURCE_PARAM,
} from '../constants';

const OPTIONS: SingleValue<OptionType[]> = Object.keys(CompensationSource).map(
  (source) => ({
    label:
      COMPENSATION_SOURCE_LABELS.get(source as CompensationSource) ??
      toSentenceCase(source), // fallback in case a custom label is not defined
    value: source,
  }),
);

export const CompensationSourceSelector = ({
  label,
  size,
}: {
  label?: string;
  size?: DropdownProps<false>['size'];
}) => {
  const [searchParameters, setSearchParameters] = useSearchParams();

  const source = new URLSearchParams(searchParameters).get(
    COMPENSATION_SOURCE_PARAM,
  ) as string;

  return (
    <Dropdown
      isMulti={false}
      size={size}
      id="select-compensation-source"
      label={label}
      placeholder="Select"
      onChange={(option, actionMeta) => {
        if (actionMeta.action === 'clear') {
          setSearchParameters((parameters) => {
            parameters.delete(COMPENSATION_SOURCE_PARAM);
            return parameters;
          });
        } else {
          setSearchParameters((parameters) => {
            parameters.set(
              COMPENSATION_SOURCE_PARAM,
              (option as SingleValue<OptionType>)?.value as string,
            );
            return parameters;
          });
        }
      }}
      options={OPTIONS}
      isClearable
      value={OPTIONS?.find((option) => option.value === source)}
    />
  );
};
